import { useTranslation } from 'react-i18next';
import { ApprovalFormTable } from '@/components/Approval/@components/ApprovalFormTable';
import type { ElawContract } from '@/types/approval';
import {
  formatContractAmount,
  formatContractFileLabel,
  formatContractPeriod,
  formatContractRenewal,
  formatContractText,
  toContractHref,
} from './format';
import { ContractDownloadLink } from './styles';

type ContractSummaryTableProps = {
  contract: ElawContract;
};

/** 계약 1건 상세 표 — 작성·조회 공용. 첨부파일 줄은 다운로드 링크가 있을 때만(레거시 문서 저장 표) */
const ContractSummaryTable = ({ contract }: ContractSummaryTableProps) => {
  const { t } = useTranslation();
  const downloadHref = toContractHref(contract.downloadUrl);
  const rows = [
    {
      label: t('신규/갱신'),
      value: formatContractRenewal(contract.isNewContract, {
        renewal: t('신규'),
        extension: t('갱신'),
      }),
    },
    { label: t('상대방'), value: formatContractText(contract.opponentInfo) },
    { label: t('계약대금'), value: formatContractAmount(contract.amount) },
    {
      label: t('계약기간'),
      value: formatContractPeriod(contract.startDate, contract.expireDate),
    },
    ...(downloadHref
      ? [
          {
            label: t('첨부파일'),
            value: (
              <>
                {formatContractFileLabel(contract)}
                {' ('}
                <ContractDownloadLink
                  href={downloadHref}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('다운로드')}
                </ContractDownloadLink>
                {')'}
              </>
            ),
          },
        ]
      : []),
  ];
  return (
    <ApprovalFormTable style={{ minWidth: 0 }}>
      <colgroup>
        <col style={{ width: 120 }} />
        <col />
      </colgroup>
      <tbody>
        {rows.map((row) => (
          <tr key={row.label}>
            <th scope="row">{row.label}</th>
            <td className="align-left">{row.value}</td>
          </tr>
        ))}
      </tbody>
    </ApprovalFormTable>
  );
};

export default ContractSummaryTable;
